import { useContext } from "react";
import { ProjectStakeholderListContext, PageNewState } from ".";

export const useProjectStakeholderListState = () => {
  const { pageState, setPageState } = useContext(ProjectStakeholderListContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
